import offlineStore from "../lib/offline_store";

export const OfflineModeHook = {
  mounted() {
    // Initialize with current value
    this.pushEvent("toggle_offline_mode", {
      offline_mode: offlineStore.value,
    });

    // Subscribe to changes and push updates
    this.unsubscribe = offlineStore.subscribe((value) => {
      this.pushEvent("toggle_offline_mode", {
        offline_mode: value,
      });
    });

    // Toggle offline mode on click
    this.el.addEventListener("click", () => {
      const newValue = !offlineStore.value;
      offlineStore.set(newValue);
    });
  },

  destroyed() {
    this.unsubscribe?.();
  },
};
